// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu___1L63y","right":"right___3L8KG","action":"action___LP4_P","name":"name___WfKAK","search":"search___2W0sJ","account":"account___6HXOq","avatar":"avatar___2cOWV"};